<template>
  <div style="width: 100%;" v-loading.body="loading">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
          PAYROLL CLIENT EXPORT
        </el-row>
      </el-col>
      <el-col class="small">
          <a @click="showJson = ! showJson">.&nbsp;</a>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-button type="default" @click="reset" :disabled="disableReportRun">
            Reset
          </el-button>
          <el-button type="success" @click="getUnexportedPayrolls" :disabled="disableReportRun">
            Refresh
          </el-button>
          <el-button type="danger" @click="markAsExported" :disabled="disableReportRun">
            Mark Selected as Exported
          </el-button>
          <el-button plain @click="generateReport" :disabled="disableReportRun">
            Run Export
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Report Options
        </el-row>
      </el-col>
    </el-row>

    <div @keyup.enter="generateReport">
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Payroll Number
        </el-col>
        <el-col :span="4">
          <el-input v-model="selectedCodes.doc_number" placeholder=""/>
        </el-col>
        <el-col :span="3" class="right">
          Payroll ID
        </el-col>
        <el-col :span="4">
          <el-input v-model="selectedCodes.transaction_id" placeholder=""/>
        </el-col>
      </el-row>
    </div>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Format
      </el-col>
      <el-col :span="21">
        <el-radio-group v-model="reportOptions.type" @change="updateReportType">
          <el-radio-button label="proBooksTitle">ProBooks with Title</el-radio-button>
          <el-radio-button label="proBooksV2">ProBooks V2</el-radio-button>
          <el-radio-button label="proBooksV3">ProBooks V3</el-radio-button>
          <el-radio-button label="proBooksBasic">ProBooks Basic</el-radio-button>
          <el-radio-button label="proBooksBasicUnion">ProBooks Basic Union</el-radio-button>
          <el-radio-button label="caps">CAPS</el-radio-button>
          <el-radio-button label="emshee">Emshee</el-radio-button>
          <el-radio-button label="mydaes">MydaEs</el-radio-button>
          <el-radio-button label="psl">PSL</el-radio-button>
          <!-- <el-radio-button label="emsheeSuperprime">Emshee Superprime</el-radio-button> -->
          <el-radio-button label="quickbooks">Quickbooks</el-radio-button>
          <el-radio-button label="getAllEmployees">Sipra</el-radio-button>
          <el-radio-button label="timberline">Timberline</el-radio-button>
          <el-radio-button label="telesis">Telesis</el-radio-button>
          <el-radio-button label="dataFaction">dataFaction</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col>
        <b-table-simple striped hover responsive caption-top>
          <caption>Unexported Payrolls</caption>
          <b-thead head-variant="dark">
            <b-tr>
              <b-th></b-th>
              <b-th>ID</b-th>
              <b-th>Number</b-th>
              <b-th>PC</b-th>
              <b-th>Time Posted</b-th>
              <b-th>Format</b-th>
              <b-th>Project/Job</b-th>
              <b-th>Labor</b-th>
              <b-th>Fringe</b-th>
              <b-th>Amount</b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-for="payroll in transactionList" :key="payroll.id">
            <b-tr>
              <b-td><b-form-checkbox v-model="payroll.selected"></b-form-checkbox></b-td>
              <b-td><a @click="selectPayrollTransaction(payroll)" :style="payroll.get('project.format') ? 'color: blue; text-decoration: underline' : ''">{{ payroll.id }}</a></b-td>
              <b-td>{{ payroll.attributes.number }}</b-td>
              <b-td>{{ (payroll.get('payroll_coordinator.first_name') || '') + ' ' + (payroll.get('payroll_coordinator.last_name') || 'Unknown') }}</b-td>
              <b-td>{{ new Date(payroll.attributes.time_posted).toLocaleString() }}</b-td>
              <b-td>{{ payroll.get('project.format') }}</b-td>
              <b-td>{{ payroll.get('project.name') }}</b-td>
              <b-td>{{ payroll.get('project.labor_clearing_account') }}</b-td>
              <b-td>{{ payroll.get('project.fringe_clearing_account') }}</b-td>
              <b-td style="text-align: right;">{{ payroll.attributes.amount_decimal }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </el-col>
    </el-row>

    <el-row v-if="showJson">
      <el-col>
        <textarea id="output" style="width: 100%; height: 500px !important; font-family: 'Courier New'" v-model="prettyJson"></textarea>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { PayrollInvoiceData } from '@/utils/helpers/PayrollData'
  import { EmployeeResource, AssignmentResource, EmployeeDirectDepositRuleResource, AddressResource, ProjectResource, BatchResource, BankResource } from '@sigmacloud/sigma-client/dist/resources'
  import CustomPayrollResource from '@/resources/CustomPayrollResource'
  import { reportMixins } from '@/Mixins/Reports'
  import { aggregateMixins } from '@/Mixins/Aggregate'
  import { sortResourcesByProperty, sliceIntoChunks, sortObjectByProperty } from '@/utils/helpers/ObjectSorting'
  import { pad } from '@/utils/helpers/StringsNumbers'
  import DateField from '@/components/InputComponents/DateField.vue'

  export default {
    name: 'ClientExport',
    components: { DateField },
    mixins: [ reportMixins, aggregateMixins ],
    data () {
      return {
        payrollData: undefined,
        reportOptions: {
          transactionStatuses: [ 'posted', 'closed' ],
          accountQuickPick: 'all',
          type: 'proBooksTitle',
          dates: 'datesAll',
          sort: 'account',
          status: 'all',
          format: 'csv',
          currencyFactor: undefined,
          report_currency_id: 1
        },
        allCodes: {},    // Show codes, e.g. accounts, series, locations, sets, etc.
        selectedCodes: {
          period_start: undefined,
          period_end: undefined,
          time_posted_start: undefined,
          time_posted_end: undefined,
          effective_date_start: undefined,
          effective_date_end: undefined,
          account_id: [],
          company_id: undefined,
          transaction_id: undefined,
          doc_number: '',
          currency_id: []
        },
        jasperSettings: {
          reportServer: 'https://jasper2.revolutiones.com:8443/jasperserver/rest_v2/reports/Revolution/Payroll/',
          reportName: 'pr_detail_edit_report'
        },
        vendors: undefined,
        transactionTypes: {     // Types of transactions and whether we need them or not
          'prs': { name: 'PRINV', include: true }
        },
        disableReportRun: false, // Disable run report button if false
        reportJson: undefined,
        prettyJson: undefined,
        showJson: true,
        reportNotif: undefined,
        collapseExpenses: false,
        loading: false,

        // For unexported payroll list
        transactionList: [],
        bankIds: []
      }
    },

    computed: {
      resources () {
        return {
          EmployeeResource,
          AssignmentResource,
          EmployeeDirectDepositRuleResource,
          AddressResource,
          CustomPayrollResource,
          ProjectResource,
          BatchResource,
          BankResource
        }
      },
      username () { return this.$store.getters.getUser.username },
      includedTypes () {
        return Object.values(this.transactionTypes).filter(types => types.include === true).map(type => type.name)
      },
      dateStart () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_start) || {}).start || '0000/00/00'

          case 'datesEffective':
            return this.selectedCodes.effective_date_start || '0000/00/00'

          case 'datesPosted':
            return this.selectedCodes.time_posted_start || '0000/00/00'

          default:
            return 'ALL'
        }
      },
      dateEnd () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_end) || {}).end || '9999/99/99'

          case 'datesEffective':
            return this.selectedCodes.effective_date_end || '9999/99/99'

          case 'datesPosted':
            return this.selectedCodes.time_posted_end || '9999/99/99'

          default:
            return 'ALL'
        }
      }
    },
    methods: {
      resetComponent () {
        this.reportJson = this.prettyJson = undefined
        for (const i in this.selectedCodes) {
          if (typeof this.selectedCodes[i] === 'object' && Array.isArray(this.selectedCodes[i])) this.selectedCodes[i] = []
          else if (typeof this.selectedCodes[i] === 'object') this.selectedCodes[i] = {}
          else this.selectedCodes[i] = undefined
        }
      },
      updateReportType (type) {
        this.reportOptions.type = type
      },
      updateReportDates (type) {
        this.selectedCodes.period_start = this.selectedCodes.period_end = this.selectedCodes.time_posted_start = this.selectedCodes.time_posted_end = this.selectedCodes.effective_date_start = this.selectedCodes.effective_date_end = undefined
      },
      includePrs ({target}) {
        this.transactionTypes.prs.include = target.checked
      },

      // Separates data by assignment and budget coding.  Assuming the data is for one invoice at a time...
      async proBooksBasicExport (payrollData) {
        let periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
        let endDate = new Date(periodEndDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })
        // Header
        let csv = 'Client: ' + payrollData.projectName + '\n' +
          'PR ' + payrollData.payrollNumber + ' WE ' + endDate + '\n' +
          payrollData.payrollNumber + '\n' + 'Total: ' + payrollData.totalInvoiceAmount + '\n\n'

        csv += 'Account, Series, Location, Set, FF1, FF2, Description, Amount\n'

        // this.prettyJson = JSON.stringify(payrollData.assignmentsData, null, 2)
        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          let assignment = sortedAssignments[id]
          let pay = assignment.getDataByCoding()
          let fringe = assignment.getDataByCoding('getTotalErCost')
          let periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
          let endDate = new Date(periodEndDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })

          for (const accountString in pay) {
            const line = pay[accountString]
            // console.log(line)
            csv += `${line.account},${line.series},${line.location},${line.set},${line.ff1},${line.ff2},"PR ${line.employeeName} WE ${endDate}",${line.amount}\n`
          }

          for (const accountString in fringe) {
            const line = fringe[accountString]
            // console.log(line)
            csv += `${line.fringe},${line.series},${line.location},${line.set},${line.ff1},${line.ff2},"FR ${line.employeeName} WE ${endDate}",${line.amount}\n`
          }
        }

        // Clearing line
        csv += `${payrollData.laborOffset},,,,,,"Payroll Clearing Offset",${payrollData.totalInvoiceAmount * -1}\n`

        this.reportOptions.format = 'csv'
        return csv
      },

      // Separates data by assignment and budget coding. Lumps fringes into union and non-union
      async proBooksBasicUnionExport (payrollData) {
        const periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
        const endDate = new Date(periodEndDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })
        const totalInvoiceAmount = payrollData.totalInvoiceAmount
        const totalPayAmount = payrollData.totalPay
        const totalFringeAmount = payrollData.totalErCost

        // Header
        let csv = 'Client: ' + payrollData.projectName + '\n' +
          'PR ' + payrollData.payrollNumber + ' WE ' + endDate + '\n' +
          payrollData.payrollNumber + '\n' + 'Total: ' + totalInvoiceAmount + '\n\n'

        csv += 'Account, Series, Location, Set, FF1, FF2, Description, Amount\n'

        // For IPC
        let ipcClientIds = [
          '1a9b8e01-f3c2-4885-a439-99486f62d353', // BUCKINGHAM TELEVISION
          '5acca8f3-baac-47b3-befb-25817ad47d1b' // DANCE NATION
        ]

        // Transformations of Account/Free Fields
        const transformations = [
          // Fifth Season She Rides Shotgun.  Change Union PHW to QW and all other fringes to NF
          { projectId: 2869, type: 'pay', comps: [ { field: 'isUnion', value: true } ], field: 'ff1', value: 'QW' },
          { projectId: 2869, type: 'union', comps: [ { field: 'isUnion', value: true } ], field: 'ff1', value: 'QF' },
          { projectId: 2869, type: 'fringe', field: 'ff1', value: 'NF' },

          // Fifth Season She Rides Shotgun - DGA/SAG.  Change Union PHW to QF and all other fringes to NF
          { projectId: 2873, type: 'pay', comps: [ { field: 'isUnion', value: true } ], field: 'ff1', value: 'QW' },
          { projectId: 2873, type: 'union', comps: [ { field: 'isUnion', value: true } ], field: 'ff1', value: 'QF' },
          { projectId: 2873, type: 'fringe', field: 'ff1', value: 'NF' },

          // Fifth Season She Rides Shotgun - WGA.  Change Union PHW to QF and all other fringes to NF
          { projectId: 2871, type: 'pay', comps: [ { field: 'isUnion', value: true } ], field: 'ff1', value: 'QW' },
          { projectId: 2871, type: 'union', comps: [ { field: 'isUnion', value: true } ], field: 'ff1', value: 'QF' },
          { projectId: 2871, type: 'fringe', field: 'ff1', value: 'NF' },

          // Fifth Season She Rides Shotgun - IATSE/Teamsters.  Change Union PHW to QF and all other fringes to NF
          { projectId: 2872, type: 'pay', comps: [ { field: 'isUnion', value: true } ], field: 'ff1', value: 'QW' },
          { projectId: 2872, type: 'union', comps: [ { field: 'isUnion', value: true } ], field: 'ff1', value: 'QF' },
          { projectId: 2872, type: 'fringe', field: 'ff1', value: 'NF' }
        ]

        // if not coded, this is the suspense account
        let placeholder
        let acaPlaceholder
        if (ipcClientIds.includes(payrollData.clientId)) {
          placeholder = '290-02'
          acaPlaceholder = '140-02'
        } else {
          placeholder = 'X99-999'
          acaPlaceholder = ''
        }

        // Manual transformations
        const payTransformations = transformations.filter((obj) => obj.type === 'pay' && (obj.projectId === payrollData.projectId || obj.clientId === payrollData.clientId))
        const unionTransformations = transformations.filter((obj) => obj.type === 'union' && (obj.projectId === payrollData.projectId || obj.clientId === payrollData.clientId))
        const fringeTransformations = transformations.filter((obj) => obj.type === 'fringe' && (obj.projectId === payrollData.projectId || obj.clientId === payrollData.clientId))

        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          const assignment = sortedAssignments[id]
          const pay = assignment.getDataByCoding()
          const fringeNonUnion = assignment.getDataByCoding('getErExceptUnionFees')
          const fringeUnion = assignment.getDataByCoding('getTotalUnionBenefits')
          const periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
          const endDate = new Date(periodEndDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })

          const makePrLine = (type = 'PR', prLines, transformations = null) => {
            const accountLineField = (type === 'PR') ? 'account' : 'fringe'

            // For transformations to coding
            let defaultCodes = {
              account: undefined,
              series: undefined,
              location: undefined,
              set: undefined,
              ff1: undefined,
              ff2: undefined
            }

            let overrideCodes = {
              account: undefined,
              series: undefined,
              location: undefined,
              set: undefined,
              ff1: undefined,
              ff2: undefined
            }

            for (const accountString in prLines) {
              const line = prLines[accountString]

              // Change the default codes here if there are transformations to be made
              if (transformations && Array.isArray(transformations) && transformations.length > 0) {
                const [ lastTransformation ] = transformations.slice(-1)
                // if (lastTransformation) console.log(lastTransformation)
                if (lastTransformation && typeof lastTransformation.comps === 'undefined') {
                  overrideCodes[lastTransformation.field || 'bad'] = lastTransformation.value || undefined

                // Handle comparisons for specific conditions to be met before the transformation, e.g. only transform if the payroll is union, loanout, etc.
                } else if (lastTransformation && typeof lastTransformation.comps === 'object') {
                  const comps = lastTransformation.comps
                  for (const i in comps) {
                    const comp = comps[i]
                    if (comp.field && line[comp.field] && line[comp.field] === comp.value) {
                      overrideCodes[lastTransformation.field || 'bad'] = lastTransformation.value || undefined
                      // console.log('match', lastTransformation.field, comp.field, line[comp.field])
                    } else {
                      // console.log('no match', lastTransformation.field, comp.field, line[comp.field])
                    }
                  }
                }
              }

              // New COA rules in ProPay force fringes in account field so use this to default to the account...  Enable if needed.
              if (type !== 'PR' && !line[accountLineField] && line['account']) {
                // accountLineField = 'account'
              }
              const account = (type === 'ACA' ? (acaPlaceholder || line[accountLineField] || placeholder) : (line[accountLineField] || placeholder)) || overrideCodes.account || defaultCodes.account || ''
              const ser = overrideCodes.series || line.series || defaultCodes.series || ''
              const loc = overrideCodes.location || line.location || defaultCodes.location || ''
              const set = overrideCodes.set || line.set || defaultCodes.set || ''
              const ff1 = overrideCodes.ff1 || line.ff1 || defaultCodes.ff1 || ''
              const ff2 = overrideCodes.ff2 || line.ff2 || defaultCodes.ff2 || ''
              csv += `${account},${ser},${loc},${set},${ff1},${ff2},"${type} ${(line.employeeName || '').toUpperCase()} WE ${endDate}",${line.amount}\n`
            }
          }

          makePrLine('PR', pay, payTransformations)
          makePrLine('FR', fringeNonUnion, fringeTransformations)
          makePrLine('PHW', fringeUnion, unionTransformations)
        }

        // Clearing lines
        csv += `${payrollData.laborOffset},,,,,,"Payroll Clearing Offset",${(totalPayAmount * -1).toFixed(2)}\n`
        csv += `${payrollData.fringeOffset},,,,,,"Fringe Clearing Offset",${(totalFringeAmount * -1).toFixed(2)}\n`

        this.reportOptions.format = 'csv'
        return csv
      },

      // Separates data by assignment and budget coding and straight/ot/allwance pay.  Assuming the data is for one invoice at a time...
      async proBooksV2Export (payrollData) {
        let periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
        let endDate = new Date(periodEndDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })
        // Header
        let csv = 'Client: ' + payrollData.projectName + '\n' +
          'PR ' + payrollData.payrollNumber + ' WE ' + endDate + '\n' +
          payrollData.payrollNumber + '\n' + 'Total: ' + payrollData.totalInvoiceAmount + '\n\n'

        csv += 'Account, Series, Location, Set, FF1, FF2, Description, Amount\n'

        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          let assignment = sortedAssignments[id]
          let payStraight = assignment.getDataByCoding('getStraightPay')
          let payOvertime = assignment.getDataByCoding('getOvertimePay')
          let payAllowance = assignment.getDataByCoding('getAllowancePay')
          let payOther = assignment.getDataByCoding('getOtherPay')
          let fringe = assignment.getDataByCoding('getTotalErCost')
          let periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
          let endDate = new Date(periodEndDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })

          for (const accountString in payStraight) {
            const line = payStraight[accountString]
            csv += `${line.account},${line.series},${line.location},${line.set},${line.ff1},${line.ff2},"PR ST ${line.employeeName} WE ${endDate}",${line.amount}\n`
          }

          for (const accountString in payOvertime) {
            const line = payOvertime[accountString]
            csv += `${line.account},${line.series},${line.location},${line.set},${line.ff1},${line.ff2},"PR OT ${line.employeeName} WE ${endDate}",${line.amount}\n`
          }

          for (const accountString in payAllowance) {
            const line = payAllowance[accountString]
            csv += `${line.account},${line.series},${line.location},${line.set},${line.ff1},${line.ff2},"PR Allow ${line.employeeName} WE ${endDate}",${line.amount}\n`
          }

          for (const accountString in payOther) {
            const line = payOther[accountString]
            csv += `${line.account},${line.series},${line.location},${line.set},${line.ff1},${line.ff2},"PR Other ${line.employeeName} WE ${endDate}",${line.amount}\n`
          }

          for (const accountString in fringe) {
            const line = fringe[accountString]
            csv += `${line.fringe},${line.series},${line.location},${line.set},${line.ff1},${line.ff2},"FR ${line.employeeName} WE ${endDate}",${line.amount}\n`
          }
        }

        // Clearing line
        csv += `${payrollData.laborOffset},,,,,,"Payroll Clearing Offset",${payrollData.totalInvoiceAmount * -1}\n`

        this.reportOptions.format = 'csv'
        return csv
      },

      // Separates data by assignment and budget coding and all fringes like CAPS file output
      async proBooksV3Export (payrollData) {
        let periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
        let endDate = new Date(periodEndDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })
        const totalInvoiceAmount = payrollData.totalInvoiceAmount
        const totalPayAmount = payrollData.totalPay
        const totalFringeAmount = payrollData.totalErCost

        // Header
        let csv = 'Client: ' + payrollData.projectName + '\n' +
          'PR ' + payrollData.payrollNumber + ' WE ' + endDate + '\n' +
          payrollData.payrollNumber + '\n' + 'Total: ' + totalInvoiceAmount + '\n\n'

        csv += 'Account, Series, Location, Set, FF1, FF2, Description, Amount\n'

        // For IPC
        let ipcClientIds = [
          '1a9b8e01-f3c2-4885-a439-99486f62d353', // BUCKINGHAM TELEVISION
          '5acca8f3-baac-47b3-befb-25817ad47d1b' // DANCE NATION
        ]

        // Transformations of Account/Free Fields
        const transformations = [
          // Blumhouse Imaginary.  Change SUTA and HF free fields
          { projectId: [ 2455 ], type: 'suta', field: 'ff2', value: 'NQ' },
          { projectId: [ 2455 ], type: 'hf', field: 'ff2', value: 'LS' },

          // Fifth Season She Rides Shotgun.  Change Union PHW to QW and all other fringes to NF
          // { projectId: 2869, type: 'pay', comps: [ { field: 'isUnion', value: true } ], field: 'ff1', value: 'QW' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'union', comps: [ { field: 'isUnion', value: true } ], field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'union', comps: [ { field: 'isUnion', value: true }, { field: 'ff1', value: 'CE' } ], field: 'ff1', value: 'CF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'union', comps: [ { field: 'isUnion', value: true }, { field: 'ff1', value: [ 'FL', 'QW', 'RT' ] } ], field: 'ff1', value: 'QF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'union', comps: [ { field: 'isUnion', value: true }, { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'hf', field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'wc', field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'fica', field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'futa', field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'suta', field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'sdi', field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'nuben', field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'erlocal', field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'postage', field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'aca', field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'adj', field: 'ff1', value: 'NF' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'credits', field: 'ff1', value: 'NF' },

          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'hf', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'wc', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'fica', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'futa', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'suta', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'sdi', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'nuben', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'erlocal', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'postage', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'aca', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'adj', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' },
          { projectId: [ 2869, 2873, 2871, 2872 ], type: 'credits', comps: [ { field: 'ff1', value: 'SL' } ], field: 'ff1', value: 'SL' }
        ]

        // if not coded, this is the suspense account
        let placeholder
        let acaPlaceholder
        if (ipcClientIds.includes(payrollData.clientId)) {
          placeholder = '290-02'
          acaPlaceholder = '140-02'
        } else {
          placeholder = ''
          acaPlaceholder = ''
        }

        // Manual transformations
        const payTransformations = transformations.filter((obj) => obj.type === 'pay' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const sutaTransformations = transformations.filter((obj) => obj.type === 'suta' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const hfTransformations = transformations.filter((obj) => obj.type === 'hf' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const wcTransformations = transformations.filter((obj) => obj.type === 'wc' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const ficaTransformations = transformations.filter((obj) => obj.type === 'fica' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const futaTransformations = transformations.filter((obj) => obj.type === 'futa' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const sdiTransformations = transformations.filter((obj) => obj.type === 'sdi' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const nubenTransformations = transformations.filter((obj) => obj.type === 'nuben' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const unionTransformations = transformations.filter((obj) => obj.type === 'union' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const erlocalTransformations = transformations.filter((obj) => obj.type === 'erlocal' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const postageTransformations = transformations.filter((obj) => obj.type === 'postage' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const acaTransformations = transformations.filter((obj) => obj.type === 'aca' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const adjTransformations = transformations.filter((obj) => obj.type === 'adj' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))
        const creditsTransformations = transformations.filter((obj) => obj.type === 'credits' && ((obj.projectId && obj.projectId.includes(payrollData.projectId)) || (obj.clientId && obj.clientId.includes(payrollData.clientId))))

        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          let assignment = sortedAssignments[id]
          let pay = assignment.getDataByCoding()
          // let fringe = assignment.getTotalErCost()
          // let running = 0
          let fringeHF = assignment.getDataByCoding('getHandlingFees')
          let fringeWC = assignment.getDataByCoding('getWcFees')
          let fringeFICASS = assignment.getDataByCoding('getErFicaSs')
          let fringeMEDC = assignment.getDataByCoding('getErFicaMedc')
          let fringeFUTA = assignment.getDataByCoding('getErFuta')
          let fringeSUTA = assignment.getDataByCoding('getErSuta')
          let fringeSDI = assignment.getDataByCoding('getErSdi')
          let periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
          let endDate = new Date(periodEndDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })
          let fringeERLOCAL = assignment.getDataByCoding('getErLocalAndOtherTaxes')
          let fringeERBEN = assignment.getDataByCoding('getErBenefitFeesNoUnion')
          let fringeUnion = assignment.getDataByCoding('getTotalUnionBenefits')
          let fringePostage = assignment.getDataByCoding('getPostageDelivery')
          let fringeACA = assignment.getDataByCoding('getAcaFees')
          let fringeAdjustments = assignment.getDataByCoding('getErInvAdj')
          let fringeReturned = assignment.getDataByCoding('getErReturnedDeductions')
          // let holidayAccrual = assignment.getDataByCoding('getHolidayAccrual')
          // console.log(fringeERLOCAL)

          let makePrLine = (type = 'PAY', payLines, transformations = null) => {
            let accountLineField

            if (type === 'PAY') {
              accountLineField = 'account'
            } else {
              accountLineField = 'fringe'
            }

            // For transformations to coding
            let defaultCodes = {
              account: undefined,
              series: undefined,
              location: undefined,
              set: undefined,
              ff1: undefined,
              ff2: undefined
            }

            for (const accountString in payLines) {
              const line = payLines[accountString]

              // Change the default codes here if there are transformations to be made
              if (transformations && Array.isArray(transformations) && transformations.length > 0) {
                for (const i in transformations) {
                  const transformation = transformations[i]
                  if (transformation && typeof transformation.comps === 'undefined') {
                    defaultCodes[transformation.field || 'bad'] = transformation.value || undefined

                  // Handle comparisons for specific conditions to be met before the transformation, e.g. only transform if the payroll is union, loanout, etc.
                  } else if (transformation && typeof transformation.comps === 'object') {
                    const comps = transformation.comps
                    let matched
                    for (const i in comps) {
                      const comp = comps[i]
                      if (Array.isArray(comp.value) && comp.field && line[comp.field] && comp.value.includes(line[comp.field])) {
                        // console.log('match array', transformation.field, comp.field, comp.value, line[comp.field])
                        matched = transformation.value || undefined
                      } else if (comp.field && line[comp.field] && line[comp.field] === comp.value) {
                        matched = transformation.value || undefined
                        // console.log('match', transformation.field, comp.field, comp.value, line[comp.field])
                      } else {
                        // console.log('no match', transformation.field, comp.field, comp.value, line[comp.field])
                        // If any of the comparison (comp) rules fail, we don't want to use it.
                        matched = false
                      }
                    }
                    // If here, all conditions matched.
                    if (matched) {
                      // console.log('final match ', transformation.field, transformation.value, matched)
                      defaultCodes[transformation.field || 'bad'] = matched
                    } else {
                      // console.log('skipping ', transformation.field, transformation.value)
                    }
                  }
                }
              }

              // New COA rules in ProPay force fringes in account field so use this to default to the account...  Enable if needed.
              if (type !== 'PAY' && !line[accountLineField] && line['account']) {
                // accountLineField = 'account'
              }

              let account = type === 'ACA' ? acaPlaceholder || line[accountLineField] || placeholder : line[accountLineField] || placeholder
              csv += `${defaultCodes.account || account},${defaultCodes.series || line.series},${defaultCodes.location || line.location},${defaultCodes.set || line.set},${defaultCodes.ff1 || line.ff1},${defaultCodes.ff2 || line.ff2},"${type} ${line.employeeName} WE ${endDate}",${line.amount}\n`
              // console.log(line)
              // running += parseFloat(line.amount)
            }
          }

          makePrLine('PAY', pay, payTransformations)
          makePrLine('HFC', fringeHF, hfTransformations)
          makePrLine('WC', fringeWC, wcTransformations)
          makePrLine('FICA', fringeFICASS, ficaTransformations)
          makePrLine('MED', fringeMEDC, ficaTransformations)
          makePrLine('FUI', fringeFUTA, futaTransformations)
          makePrLine('SUI', fringeSUTA, sutaTransformations)
          makePrLine('SDI', fringeSDI, sdiTransformations)
          makePrLine('DEDUCTION', fringeERBEN, nubenTransformations)
          makePrLine('PHW', fringeUnion, unionTransformations)
          makePrLine('ERLOCAL', fringeERLOCAL, erlocalTransformations)
          makePrLine('POSTAGE', fringePostage, postageTransformations)
          makePrLine('ACA', fringeACA, acaTransformations)
          makePrLine('ADJUSTMENTS', fringeAdjustments, adjTransformations)
          makePrLine('CREDITS', fringeReturned, creditsTransformations)
          // makePrLine('HOL ACCRUAL', holidayAccrual, creditsTransformations)
        }

        // Clearing line
        // csv += `,,,,,,"Payroll Clearing Offset",${totalInvoiceAmount * -1}\n`
        csv += `${payrollData.laborOffset},,,,,,"Payroll Clearing Offset",${(totalPayAmount * -1).toFixed(2)}\n`
        csv += `${payrollData.fringeOffset},,,,,,"Fringe Clearing Offset",${(totalFringeAmount * -1).toFixed(2)}\n`

        this.reportOptions.format = 'csv'
        return csv
      },

      // Separates data by assignment and budget coding and taxable/non-taxable pay.  Assuming the data is for one invoice at a time...
      async capsExport (payrollData) {
        // Header
        let csv = ''
        /*
            columnfield length
            A Invoice number 10
            B Work date (does not get imported) 8
            C Coding format 2
            D Last four of SSN (does not get imported) 11
            E Week ending date 6
            F Earnings or fringe description39
            H Amount 16
            I Employee name 45
            N F (for fringe) or E (for earnings) 1
            O Week ending date 8
            P Account
            S Episode number
        */

        // For IPC
        let ipcClientIds = [
          '1a9b8e01-f3c2-4885-a439-99486f62d353', // BUCKINGHAM TELEVISION
          '5acca8f3-baac-47b3-befb-25817ad47d1b' // DANCE NATION
        ]

        // if not coded, this is the suspense account
        let placeholder
        let acaPlaceholder

        if (ipcClientIds.includes(payrollData.clientId)) {
          placeholder = '290-02'
          acaPlaceholder = '140-02'
        } else {
          placeholder = ''
          acaPlaceholder = ''
        }

        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          let assignment = sortedAssignments[id]
          let pay = assignment.getDataByCoding()
          // let fringe = assignment.getTotalErCost()
          // let running = 0
          let fringeHF = assignment.getDataByCoding('getHandlingFees')
          let fringeWC = assignment.getDataByCoding('getWcFees')
          let fringeFICASS = assignment.getDataByCoding('getErFicaSs')
          let fringeMEDC = assignment.getDataByCoding('getErFicaMedc')
          let fringeFUTA = assignment.getDataByCoding('getErFuta')
          let fringeSUTA = assignment.getDataByCoding('getErSuta')
          let fringeSDI = assignment.getDataByCoding('getErSdi')
          // let fringeERLOCAL = (parseFloat(assignment.getDataByCoding('getErLocalTax')) + parseFloat(assignment.getDataByCoding('getErLocalTaxFees'))+ parseFloat(assignment.getDataByCoding('getErSalesTax')) + parseFloat(assignment.getDataByCoding('getErBusinessTax'))).toFixed(2)
          // let fringeERLOCAL = [].concat(assignment.getDataByCoding('getErLocalTax'), assignment.getDataByCoding('getErLocalTaxFees'), assignment.getDataByCoding('getErSalesTax'), assignment.getDataByCoding('getErBusinessTax'))
          let fringeERLOCAL = assignment.getDataByCoding('getErLocalAndOtherTaxes')
          let fringeERBEN = assignment.getDataByCoding('getErBenefitFees')
          let fringePostage = assignment.getDataByCoding('getPostageDelivery')
          let fringeACA = assignment.getDataByCoding('getAcaFees')
          let fringeAdjustments = assignment.getDataByCoding('getErInvAdj')
          let fringeReturned = assignment.getDataByCoding('getErReturnedDeductions')
          // console.log(fringeERLOCAL)

          const invNumber = pad((payrollData.payrollNumber || '').substr(-10), '0', 10, 'right')

          let makeCapsLine = (type = 'EARNINGS', payLines) => {
            let category
            let accountLineField

            if (type === 'EARNINGS') {
              category = 'E'
              accountLineField = 'account'
            } else {
              category = 'F'
              accountLineField = 'fringe'
            }

            for (const accountString in payLines) {
              const line = payLines[accountString]
              // const workDate = line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'}) : ''
              const weekEndingShort = line.weekEnding ? line.weekEnding.substr(5, 2) + line.weekEnding.substr(8, 2) : ''
              const weekEnding = weekEndingShort ? weekEndingShort + line.weekEnding.substr(0, 4) : ''
              const ssn = 'XXX-XX-' + line.tinLast4
              const description = pad(`-${type}`, ' ', 19, 'left')
              const amount = pad(line.amount, ' ', 16, 'left')
              const eeName = pad(line.payeeName, ' ', 100, 'left').toUpperCase()

              // New COA rules in ProPay force fringes in account field so use this to default to the account...  Enable if needed.
              if (type !== 'EARNINGS' && !line[accountLineField] && line['account']) {
                // accountLineField = 'account'
              }
              // ACA is for IPC and has a hard-coded account
              const account = pad((type === 'ACA' ? acaPlaceholder || line[accountLineField] || placeholder : line[accountLineField] || placeholder), ' ', 95, 'left')
              const freeField1 = pad(line.ff1 || '', ' ', 60, 'left')
              const freeField2 = pad(line.ff2 || '', ' ', 60, 'left')
              csv += invNumber + weekEnding + ssn + 'WE' + weekEndingShort + description + amount + eeName + category + weekEnding + account + freeField1 + freeField2 + '\n'
              // console.log(line)
              // running += parseFloat(line.amount)
            }
          }

          makeCapsLine('EARNINGS', pay)
          makeCapsLine('HFC', fringeHF)
          makeCapsLine('WC', fringeWC)
          makeCapsLine('FICA', fringeFICASS)
          makeCapsLine('MED', fringeMEDC)
          makeCapsLine('FUI', fringeFUTA)
          makeCapsLine('SUI', fringeSUTA)
          makeCapsLine('SDI', fringeSDI)
          makeCapsLine('DEDUCTION', fringeERBEN)
          makeCapsLine('ERLOCAL', fringeERLOCAL)
          makeCapsLine('POSTAGE', fringePostage)
          makeCapsLine('ACA', fringeACA)
          makeCapsLine('ADJUSTMENTS', fringeAdjustments)
          makeCapsLine('CREDITS', fringeReturned)
        }

        this.reportOptions.format = 'txt'
        return csv
      },

      // Separates data by assignment and budget coding and taxable/non-taxable pay.  Assuming the data is for one invoice at a time...
      async proBooksTitleExport (payrollData) {
        let periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
        let endDate = new Date(periodEndDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })
        // Header
        let csv = 'Client: ' + payrollData.projectName + '\n' +
          'PR ' + payrollData.payrollNumber + ' WE ' + endDate + '\n' +
          payrollData.payrollNumber + '\n' + 'Total: ' + payrollData.totalInvoiceAmount + '\n\n'

        csv += 'Account, Series, Location, Set, FF1, FF2, Description, Amount\n'

        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          let assignment = sortedAssignments[id]
          let payTaxable = assignment.getDataByCoding('getTaxablePay')
          let payNonTaxable = assignment.getDataByCoding('getNonTaxablePay')
          let fringe = assignment.getDataByCoding('getTotalErCost')
          let periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
          let endDate = new Date(periodEndDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })

          for (const accountString in payTaxable) {
            const line = payTaxable[accountString]
            csv += `${line.account},${line.series},${line.location},${line.set},${line.ff1},${line.ff2},"PR ${line.employeeName} WE ${endDate}",${line.amount}\n`
          }

          for (const accountString in payNonTaxable) {
            const line = payNonTaxable[accountString]
            csv += `${line.account},${line.series},${line.location},${line.set},${line.ff1},${line.ff2},"PR NT ${line.employeeName} WE ${endDate}",${line.amount}\n`
          }

          for (const accountString in fringe) {
            const line = fringe[accountString]
            // console.log(line)
            csv += `${line.fringe},${line.series},${line.location},${line.set},${line.ff1},${line.ff2},"FR ${line.employeeName} WE ${endDate}",${line.amount}\n`
          }
        }

        // Clearing line
        csv += `${payrollData.laborOffset},,,,,,"Payroll Clearing Offset",${payrollData.totalInvoiceAmount * -1}\n`

        this.reportOptions.format = 'csv'
        return csv
      },

      // Only difference with Emshee is no week ending date
      /* deprecated and superprime is now handled as a condition in emsheeExport() */
      async emsheeSuperprimeExportOld (payrollData) {
        // Header
        let csv = ''
        // let csv = 'COA||Invoice Date|Week Ending Date|Job Name|Job Number|Invoice Number|Amount||||||||Name or Loan-out|||||||||Pass Through||Week Ending Date||Payroll Quick Name|||||||\n'

        const invoiceDate = new Date(payrollData.invoiceDate).toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'})
        for (const id in payrollData.assignmentsData) {
          let assignment = payrollData.assignmentsData[id]
          let payWages = assignment.getDataByCoding('getWagesPay')
          let payAllowance = assignment.getDataByCoding('getAllowancePay')
          let payOther = assignment.getDataByCoding('getOtherPay')
          let fringe = assignment.getDataByCoding('getTotalErCost')

          for (const accountString in payWages) {
            const line = payWages[accountString]
            const weekEnding2 = line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'}) : ''
            const payee = ((line.isLoanout ? line.loanoutName : line.lastName + ', ' + line.firstName) || '').toUpperCase()
            const location = ((line.workCity ? line.workCity + ', ' : '') + line.workState).toUpperCase()
            csv += `${line.account}||${invoiceDate}||${payrollData.projectName}|${payrollData.projectJobNumber}|${payrollData.payrollNumber}|${line.amount}||||||||${payee}|${location}||||||||2100||${weekEnding2}||REVOLUTION PAYROLL||||||\n`
          }

          for (const accountString in payAllowance) {
            const line = payAllowance[accountString]
            const weekEnding2 = line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'}) : ''
            const payee = ((line.isLoanout ? line.loanoutName : line.lastName + ', ' + line.firstName) || '').toUpperCase()
            const location = ((line.workCity ? line.workCity + ', ' : '') + line.workState).toUpperCase()
            csv += `${line.account}||${invoiceDate}||${payrollData.projectName}|${payrollData.projectJobNumber}|${payrollData.payrollNumber}|${line.amount}||||||||${payee}|${location}||||||||2100||${weekEnding2}||REVOLUTION PAYROLL||||||\n`
          }

          for (const accountString in payOther) {
            const line = payOther[accountString]
            const weekEnding2 = line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'}) : ''
            const payee = ((line.isLoanout ? line.loanoutName : line.lastName + ', ' + line.firstName) || '').toUpperCase()
            const location = ((line.workCity ? line.workCity + ', ' : '') + line.workState).toUpperCase()
            csv += `${line.account}||${invoiceDate}||${payrollData.projectName}|${payrollData.projectJobNumber}|${payrollData.payrollNumber}|${line.amount}||||||||${payee}|${location}||||||||2100||${weekEnding2}||REVOLUTION PAYROLL||||||\n`
          }

          for (const accountString in fringe) {
            const line = fringe[accountString]
            const weekEnding2 = line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'}) : ''
            const payee = ((line.isLoanout ? line.loanoutName : line.lastName + ', ' + line.firstName) || '').toUpperCase()
            const location = ((line.workCity ? line.workCity + ', ' : '') + line.workState).toUpperCase()
            csv += `${line.fringe}||${invoiceDate}||${payrollData.projectName}|${payrollData.projectJobNumber}|${payrollData.payrollNumber}|${line.amount}||||||||${payee}|${location}||||||||2100||${weekEnding2}||REVOLUTION PAYROLL||||||\n`
          }
        }
        this.reportOptions.format = 'txt'
        return csv
      },

      async emsheeExport (payrollData) {
        // Header
        let csv = ''
        // let csv = 'COA||Invoice Date|Week Ending Date|Job Name|Job Number|Invoice Number|Amount||||||||Name or Loan-out|||||||||Pass Through||Week Ending Date||Payroll Quick Name|||||||\n'
        // Handle exceptions for clients
        let exceptionClient
        if (payrollData.clientId === 'e4542e66-4a58-4195-a89e-3808fe23e61d') {
          exceptionClient = 'superprime'
        } else if (payrollData.projectId === 41) {
          exceptionClient = 'chainStaff'
        }

        for (const id in payrollData.assignmentsData) {
          let projectName = payrollData.projectName
          let assignment = payrollData.assignmentsData[id]
          let payWages = assignment.getDataByCoding('getTaxablePay')
          let payAllowance = assignment.getDataByPayCode('getNonTaxablePay')
          let payOther = assignment.getDataByCoding('getOtherPay')
          let fringe = assignment.getDataByCoding('getTotalErCost')
          let defaultJobClass = ''

          let makeEmsheeLine = (type = 'pay', payLines) => {
            for (const accountString in payLines) {
              const line = payLines[accountString]
              const location = ((line.workCity ? line.workCity + ', ' : '') + line.workState).toUpperCase()

              // Client Transformations
              let payee = ((line.isLoanout ? line.loanoutName : line.firstName + ' ' + line.lastName) || '').toUpperCase()
              let customerAccount = type === 'pay' ? line.account : line.fringe
              let jobClass = payrollData.projectJobNumber
              let periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
              let endDate = new Date(periodEndDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })
              let endDate2 = new Date(periodEndDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
              let invdate = payrollData.invoiceDate.replace(/-/g, '/')
              const invoiceDate = new Date(invdate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })

              if (exceptionClient === 'superprime') {
                // weekEnding = ''
                payee = ((line.isLoanout ? line.loanoutName : line.lastName + ', ' + line.firstName) || '').toUpperCase()
              } else if (exceptionClient === 'chainStaff') {
                projectName = 'Staff'
                let accountString = line.account || assignment.defaultHandlingCode || assignment.defaultFringeCode || assignment.defaultBudgetCode || ''
                customerAccount = accountString ? accountString.substr(0, 5) : ''
                // Change to 99 account
                if (type === 'fringe' && customerAccount) {
                  customerAccount = customerAccount.slice(0, -2) + '99'
                }
                jobClass = ((line.account ? line.account.substr(5) : '') || defaultJobClass).trim()
              }
              if (!defaultJobClass && jobClass) defaultJobClass = jobClass
              csv += `${customerAccount}||${invoiceDate}|WE ${endDate2}|${projectName}|${jobClass}|${payrollData.payrollNumber}|${line.amount}||||||||${payee}|${location}||||||||2100||${endDate}||REVOLUTION PAYROLL||||||\n`
            }
          }

          makeEmsheeLine('pay', payWages)
          makeEmsheeLine('pay', payAllowance)
          makeEmsheeLine('pay', payOther)
          makeEmsheeLine('fringe', fringe)
          /*
          for (const accountString in payWages) {
            const line = payWages[accountString]
            const weekEnding2 = line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'}) : ''
            const location = ((line.workCity ? line.workCity + ', ' : '') + line.workState).toUpperCase()

            // Client Transformations
            let payee = ((line.isLoanout ? line.loanoutName : line.firstName + ' ' + line.lastName) || '').toUpperCase()
            let weekEnding = 'WE ' + (line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}) : '')
            let customerAccount = line.account
            let jobClass = payrollData.projectJobNumber

            if (exceptionClient === 'superprime') {
              weekEnding = ''
              payee = ((line.isLoanout ? line.loanoutName : line.lastName + ', ' + line.firstName) || '').toUpperCase()
            } else if (exceptionClient === 'chainStaff') {
              projectName = 'Staff'
              customerAccount = line.account ? line.account.substr(0, 5) : ''
              jobClass = (line.account ? line.account.substr(5) : '').trim()
            }
            csv += `${customerAccount}||${invoiceDate}|${weekEnding}|${projectName}|${jobClass}|${payrollData.payrollNumber}|${line.amount}||||||||${payee}|${location}||||||||2100||${weekEnding2}||REVOLUTION PAYROLL||||||\n`
          }

          for (const accountString in payAllowance) {
            const line = payAllowance[accountString]
            const weekEnding2 = line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'}) : ''
            const location = ((line.workCity ? line.workCity + ', ' : '') + line.workState).toUpperCase()

            // Client Transformations
            let payee = ((line.isLoanout ? line.loanoutName : line.firstName + ' ' + line.lastName) || '').toUpperCase()
            let weekEnding = 'WE ' + (line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}) : '')
            let customerAccount = line.account
            let jobClass = payrollData.projectJobNumber

            if (exceptionClient === 'superprime') {
              weekEnding = ''
              payee = ((line.isLoanout ? line.loanoutName : line.lastName + ', ' + line.firstName) || '').toUpperCase()
            } else if (exceptionClient === 'chainStaff') {
              projectName = 'Staff'
              customerAccount = line.account ? line.account.substr(0, 5) : ''
              jobClass = (line.account ? line.account.substr(5) : '').trim()
            }
            csv += `${customerAccount}||${invoiceDate}|${weekEnding}|${projectName}|${jobClass}|${payrollData.payrollNumber}|${line.amount}||||||||${payee}|${location}||||||||2100||${weekEnding2}||REVOLUTION PAYROLL||||||\n`
          }

          for (const accountString in payOther) {
            const line = payOther[accountString]
            const weekEnding2 = line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'}) : ''
            const location = ((line.workCity ? line.workCity + ', ' : '') + line.workState).toUpperCase()

            // Client Transformations
            let payee = ((line.isLoanout ? line.loanoutName : line.firstName + ' ' + line.lastName) || '').toUpperCase()
            let weekEnding = 'WE ' + (line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}) : '')
            let customerAccount = line.account
            let jobClass = payrollData.projectJobNumber

            if (exceptionClient === 'superprime') {
              weekEnding = ''
              payee = ((line.isLoanout ? line.loanoutName : line.lastName + ', ' + line.firstName) || '').toUpperCase()
            } else if (exceptionClient === 'chainStaff') {
              projectName = 'Staff'
              customerAccount = line.account ? line.account.substr(0, 5) : ''
              jobClass = (line.account ? line.account.substr(5) : '').trim()
            }
            csv += `${customerAccount}||${invoiceDate}|${weekEnding}|${projectName}|${jobClass}|${payrollData.payrollNumber}|${line.amount}||||||||${payee}|${location}||||||||2100||${weekEnding2}||REVOLUTION PAYROLL||||||\n`
          }

          for (const accountString in fringe) {
            const line = fringe[accountString]
            const weekEnding2 = line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'}) : ''
            const location = ((line.workCity ? line.workCity + ', ' : '') + line.workState).toUpperCase()

            // Client Transformations
            let payee = ((line.isLoanout ? line.loanoutName : line.firstName + ' ' + line.lastName) || '').toUpperCase()
            let weekEnding = 'WE ' + (line.weekEnding ? new Date(line.weekEnding).toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}) : '')
            let customerAccount = line.account
            let jobClass = payrollData.projectJobNumber

            if (exceptionClient === 'superprime') {
              weekEnding = ''
              payee = ((line.isLoanout ? line.loanoutName : line.lastName + ', ' + line.firstName) || '').toUpperCase()
            } else if (exceptionClient === 'chainStaff') {
              projectName = 'Staff'
              customerAccount = line.account ? line.account.substr(0, 5) : ''
              jobClass = (line.account ? line.account.substr(5) : '').trim()
            }
            csv += `${customerAccount}||${invoiceDate}|${weekEnding}|${projectName}|${jobClass}|${payrollData.payrollNumber}|${line.amount}||||||||${payee}|${location}||||||||2100||${weekEnding2}||REVOLUTION PAYROLL||||||\n`
          }

          // makeEmsheeLine(credits)
          */
        }

        this.reportOptions.format = 'txt'
        return csv
      },

      async quickbooksExport (payrollData) {
        // console.log(payrollData)
        // Header
        let csv = '"New Transaction",Type,Date,Num,Name,Memo,Class,Account,Amount\n'

        const invoiceDate = new Date(payrollData.invoiceDateTime).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'})
        const weekEnding = new Date(payrollData.weekEndingTime).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'})
        csv += `Yes,Bill,${invoiceDate},${payrollData.payrollNumber},"Revolution Payroll",W/E ${weekEnding}, ,"Accounts Payable",${payrollData.totalInvoiceAmount * -1}` + '\n' // This is only in row 1

        // Handle exceptions for clients
        let exceptionClient
        if (payrollData.clientId === '0a74a2d8-0ff6-4b3e-8892-02f2eb1d0fd1') {
          exceptionClient = 'chelsea'
        } else if (payrollData.clientId === '413b74ca-bbfa-4d81-865f-605c4d7e0cbf') {
          exceptionClient = 'company films'
        }

        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          let assignment = sortedAssignments[id]
          let pay = assignment.getDataByCoding('getTotalPay')
          let fringe = assignment.getDataByCoding('getTotalErCost')
          // Fireworks
          // let fringeReturned = assignment.getDataByCoding('getErReturnedDeductions')
          let paymentNumbers = assignment.paymentNumbers || ''
          let firstFoundAccount

          const makeQbLine = (type = 'pay', payLines) => {
            for (const accountString in payLines) {
              const line = payLines[accountString]
              if (!firstFoundAccount && line.account) firstFoundAccount = line.account
              let account

              if (type === 'fringe' && exceptionClient === 'chelsea') {
                const wageAccount = line.account || assignment.defaultBudgetCode || firstFoundAccount
                if (parseInt(wageAccount) > 0 && parseInt(wageAccount) < 50) {
                  account = '"Pre-Pro & Wrap PT/P&W"'
                } else if (parseInt(wageAccount) > 51 && parseInt(wageAccount) < 167) {
                  account = '"Shooting Crew PT/P&W"'
                } else if (parseInt(wageAccount) > 168 && parseInt(wageAccount) < 281) {
                  account = '"Set Construction Crew PT/P&W"'
                }
              } else if (type === 'fringe' && exceptionClient === 'company films') {
                const wageAccount = line.account || assignment.defaultBudgetCode || firstFoundAccount
                if (parseInt(wageAccount) > 0 && parseInt(wageAccount) < 50) {
                  account = '349'
                } else if (parseInt(wageAccount) > 51 && parseInt(wageAccount) < 167) {
                  account = '399'
                } else if (parseInt(wageAccount) > 168 && parseInt(wageAccount) < 999) {
                  account = '480'
                }
              } else if (type === 'fringe') {
                account = line.fringe || line.account || assignment.defaultFringeCode
              } else {
                account = line.account || assignment.defaultBudgetCode
              }
              csv += `,,${invoiceDate},${payrollData.payrollNumber},${payrollData.projectJobNumber},"${assignment.payeeName} Check: ${paymentNumbers}",${payrollData.projectJobNumber},${account},${line.amount}` + '\n'
            }
          }

          makeQbLine('pay', pay)
          makeQbLine('fringe', fringe)
          /*
          for (const accountString in pay) {
            const line = pay[accountString]
            const account = line.account || assignment.defaultBudgetCode || firstFoundAccount
            if (!firstFoundAccount && line.account) firstFoundAccount = line.account
            csv += `,,${invoiceDate},${payrollData.payrollNumber},${payrollData.projectJobNumber},"${assignment.payeeName} Check: ${paymentNumbers}",${payrollData.projectJobNumber},${account},${line.amount}` + '\n'
          }

          for (const accountString in fringe) {
            const line = fringe[accountString]
            let account
            if (exceptionClient === 'chelsea') {
              const wageAccount = line.account || assignment.defaultBudgetCode || firstFoundAccount
              if (parseInt(wageAccount) > 0 && parseInt(wageAccount) < 51) {
                account = 'Pre-Pro & Wrap PT/P&W'
              } else if (parseInt(wageAccount) > 50 && parseInt(wageAccount) < 101) {
                account = 'Shooting Crew PT/P&W'
              } else if (parseInt(wageAccount) > 167 && parseInt(wageAccount) < 181) {
                account = 'Set Construction Crew PT/P&W'
              }
            } else {
              account = line.account || assignment.defaultFringeCode
            }
            csv += `,,${invoiceDate},${payrollData.payrollNumber},${payrollData.projectJobNumber},"${assignment.payeeName} Check: ${paymentNumbers}",${payrollData.projectJobNumber},${account},${line.amount}` + '\n'
          }
          */
        }

        this.reportOptions.format = 'csv'
        return csv
      },

      // Separates data by assignment and budget coding and taxable/non-taxable pay.  Assuming the data is for one invoice at a time...
      async mydaesExport (payrollData) {
        // Header
        let csv = 'Client: ' + payrollData.projectName + '\n' +
          'PR ' + payrollData.payrollNumber + ' WE ' + new Date(payrollData.weekEndingTime).toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}) + '\n' +
          payrollData.payrollNumber + '\n' + 'Total: ' + payrollData.totalInvoiceAmount + '\n\n'

        csv += '"General Ledger Number","General Ledger Type","Invoice Date","WeekEnding Date","Blank","Blank","Invoice Number","Amount - Entered Currency","Source Code","Transaction Number","False","Blank","Amount – Entered Currency","Currency Converter","Blank","Blank","False","False","Blank","Blank","False","Blank","Check No","Field Name","Description","Blank","False","Entered Date","Set/Sub Account","Blank","Blank","False","Wages Code","Free Field1","Free Field2","Location/Episode","Period No","Blank","Blank","Blank"\n'

        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          let assignment = sortedAssignments[id]
          let payTaxable = assignment.getDataByCoding('getTaxablePay')
          let payNonTaxable = assignment.getDataByCoding('getNonTaxablePay')
          let fringe = assignment.getDataByCoding('getTotalErCost')

          let makeLine = (type = 'PR', payLines) => {
            let glType = ''
            for (const accountString in payLines) {
              const line = payLines[accountString]
              const csvData = [
                line.account,
                glType,
                new Date(payrollData.invoiceDateTime).toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}),
                new Date(payrollData.weekEndingTime).toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}),
                '',
                '',
                payrollData.payrollNumber,
                line.amount,
                'IMPORTWAGES',
                payrollData.payrollId,
                'FALSE',
                '',
                line.amount,
                '1',
                '',
                '',
                'FALSE',
                'FALSE',
                '',
                '',
                'FALSE',
                '',
                assignment.paymentNumbers,
                `${type} WE${new Date(payrollData.weekEndingTime).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'})} ${assignment.payeeName}`.substring(0, 35),
                '',
                'FALSE',
                new Date(payrollData.weekEndingTime).toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}),
                line.set,
                '',
                '',
                'FALSE',
                line.employee_id,
                line.ff1,
                line.ff2,
                line.series || line.location,
                '',
                '',
                ''
              ]

              csv += csvData.join('|') + '\n'
            }
          }

          makeLine('PR', payTaxable)
          makeLine('PR NT', payNonTaxable)
          makeLine('FR', fringe)
        }

        // Clearing line
        // csv += `,,,,,"Payroll Clearing Offset",${payrollData.totalInvoiceAmount * -1}\n`

        this.reportOptions.format = 'txt'
        return csv
      },

      // Separates data by assignment and budget coding and taxable/non-taxable pay.  Assuming the data is for one invoice at a time...
      async pslExport (payrollData) {
        // Header
        let csv = 'ACCOUNT NUMBER,SERIES CODE,LOCATION CODE,SET CODE,1099 CODE,INSURANCE,FF1,FF2,FF3,FF4,DESCRIPTION,AMOUNT\n'

        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          let assignment = sortedAssignments[id]
          let pay = assignment.getDataByCoding('getTotalPay')
          let fringe = assignment.getDataByCoding('getTotalErCost')
          let makeLine = (type = 'PR', payLines) => {
            for (const accountString in payLines) {
              const line = payLines[accountString]
              const csvData = [
                line.account,
                line.series,
                line.location,
                line.set,
                '',
                '',
                line.ff1,
                line.ff2,
                '',
                '',
                `"${type} WE${new Date(payrollData.weekEndingTime).toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'})} ${assignment.payeeName}"`,
                line.amount
              ]

              csv += csvData.join(',') + '\n'
            }
          }

          makeLine('PR', pay)
          makeLine('FR', fringe)
        }

        // Clearing line
        // csv += `,,,,,"Payroll Clearing Offset",${payrollData.totalInvoiceAmount * -1}\n`

        this.reportOptions.format = 'csv'
        return csv
      },

      async timberlineExport (payrollData) {
        let csv = ''
        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          let assignment = sortedAssignments[id]
          let payStraight = assignment.getDataByCoding('getStraightPay')
          let payOvertime = assignment.getDataByCoding('getOvertimePay')
          let payAllowance = assignment.getDataByCoding('getAllowancePay')
          let payOther = assignment.getDataByCoding('getOtherPay')
          let admin = assignment.getDataByCoding('getHandlingFees')
          let fringeWC = assignment.getDataByCoding('getWcFees')
          let erBenefitFees = assignment.getDataByCoding('getErBenefitFees')
          let erFicaSs = assignment.getDataByCoding('getErFicaSs')
          let erFicaMedc = assignment.getDataByCoding('getErFicaMedc')
          let futa = assignment.getDataByCoding('getErFuta')
          let suta = assignment.getDataByCoding('getErSuta')
          let erLocalAndOtherTaxes = assignment.getDataByCoding('getErLocalAndOtherTaxes')
          let fringeAdjustments = assignment.getDataByCoding('getErInvAdj')
          let fringePostage = assignment.getDataByCoding('getPostageDelivery')
          let recordId = 'DC'
          let clientId = payrollData.clientId
          let debitId = clientId === 'ffe3a928-10e0-4d23-8d0d-fc9aebd283a5' ? '22-11-000-120.000' : '55-11-000-120.000'
          let creditID = clientId === 'ffe3a928-10e0-4d23-8d0d-fc9aebd283a5' ? '22-11-000-401.000' : '55-11-000-401.000'

          const invNumber = payrollData.payrollNumber || ''
          const invoiceDate = new Date(payrollData.invoiceDate.replace(/-/g, '/')).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })

          for (const accountString in payStraight) {
            const line = payStraight[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} Wages", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in payOvertime) {
            const line = payOvertime[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} Wages", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in payAllowance) {
            const line = payAllowance[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} Wages", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in payOther) {
            const line = payOther[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} Wages", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in admin) {
            const line = admin[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} Admin", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in fringeWC) {
            const line = fringeWC[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} WC", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in erBenefitFees) {
            const line = erBenefitFees[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} Benefits", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in erFicaSs) {
            const line = erFicaSs[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} FICA SS", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in erFicaMedc) {
            const line = erFicaMedc[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} MEDC", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in futa) {
            const line = futa[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} FUTA", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in suta) {
            const line = suta[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} SUTA", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in erLocalAndOtherTaxes) {
            const line = erLocalAndOtherTaxes[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} Other Taxes", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in fringeAdjustments) {
            const line = fringeAdjustments[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} Adjustments", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }

          for (const accountString in fringePostage) {
            const line = fringePostage[accountString]
            csv += `${recordId},${line.account}, , , ,"3",${line.weekEnding},${invoiceDate},"${line.employeeName} Postage", , ,${line.amount},${debitId},${creditID},${invNumber},"REVO"\n`
          }
        }

      // Total Invoice line
        csv += `INVOICE TOTAL:  ${payrollData.totalInvoiceAmount}\n`

        this.reportOptions.format = 'csv'
        return csv
      },

      // Telesis File Exporter
      async telesisExport (payrollData) {
        let txt = ''

        txt += 'ACCOUNT,C,15|EMPNUM,C,9|AMOUNT,N,20,5|WEEKEND,D|LASTNAME,C,25|FIRSTNAME,C,15|SSN,C,11|PAYCODE,C,25|INVNO,C,12|ACCTDESC,C,25|TTXNNO,N,20,5|TPERIOD,N,20,5|TEXPPER,N,20,5|P2GL,C,1|EPISODE,C,8|SETCODE,C,4|LOCATION,C,3|CURRENCY,C,4|FREECODE,C,4|CHECKNO,N,20,5|NETPAY,N,20,5|DD,C,254|COSTITEM,C,4|HOURRATE,N,20,5|OCCCODE,C,8|WORKHOUR,N,20,5|PACODE,C,4|OCDESC,C,50|PAYDESC,C,40|ADDRESS1,C,35|ADDRESS2,C,35|CITY,C,25|STATE,C,2|ZIP,C,10|CHECK_DATE,D|DIRECTDEPO,C,20|PHONE,C,15\r\n'
        await EmployeeResource.all({ query: { id__in: payrollData.employeeIds.join(',') } })
        await AddressResource.all({ query: { id__in: payrollData.employeeIds.join(',') } })
        await EmployeeDirectDepositRuleResource.all({ query: { id__in: payrollData.employeeIds.join(',') } })

        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          let assignment = sortedAssignments[id]
          const empResource = ((EmployeeResource.getCached(assignment.employeeId) || {}).resource || {})
          const eeTin = empResource.attributes.tin
          const invoiceDate = new Date(payrollData.invoiceDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
          let payStraight = assignment.getDataByCoding('getStraightPay')
          let payOvertime = assignment.getDataByCoding('getOvertimePay')
          let payAllowance = assignment.getDataByCoding('getAllowancePay')
          let payOther = assignment.getDataByCoding('getOtherPay')
          let erBenefitFees = assignment.getDataByCoding('getErBenefitFees')
          let erFica = assignment.getDataByCoding('getErFica')
          let futa = assignment.getDataByCoding('getErFuta')
          let suta = assignment.getDataByCoding('getErSuta')
          let fringeWC = assignment.getDataByCoding('getWcFees')
          let admin = assignment.getDataByCoding('getHandlingFees')
          let erLocalAndOtherTaxes = assignment.getDataByCoding('getErLocalAndOtherTaxes')
          let fringeAdjustments = assignment.getDataByCoding('getErInvAdj')
          let fringePostage = assignment.getDataByCoding('getPostageDelivery')
          let accountNum = /\d+/g
          let paymentNumbers = assignment.paymentNumbers || ''
          let weekEnding = new Date(payrollData.weekEnding).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
          let projectCode = payrollData.projectJobNumber
          let handlingFee = assignment.defaultHandlingCode
          const invNumber = pad((payrollData.payrollNumber || '').substr(-10), '0', 10, 'right')
          const weekendingAlt = weekEnding.replace('/', '')
          const weekendingAltTwo = weekendingAlt.replace('/', '')

          for (const accountString in payStraight) {
            const line = payStraight[accountString]
            txt += `${line.account.match(accountNum)}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"PR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'RegularPay'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in payOvertime) {
            const line = payOvertime[accountString]
            txt += `${line.account.match(accountNum) || ''}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"PR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'RegularPay'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in payAllowance) {
            const line = payAllowance[accountString]
            txt += `${line.account.match(accountNum) || ''}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"PR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'RegularPay'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in payOther) {
            const line = payOther[accountString]
            txt += `${line.account.match(accountNum) || ''}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"PR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'RegularPay'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in erBenefitFees) {
            const line = erBenefitFees[accountString]
            txt += `${line.fringe || line.account}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"FR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'PensionHW'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in erFica) {
            const line = erFica[accountString]
            txt += `${line.fringe || line.account}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"FR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'FICA'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in futa) {
            const line = futa[accountString]
            txt += `${line.fringe || line.account}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"FR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'FUTA'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in suta) {
            const line = suta[accountString]
            txt += `${line.fringe || line.account}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"FR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'SUTA'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in fringeWC) {
            const line = fringeWC[accountString]
            txt += `${line.fringe || line.account}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"WC${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'Workers Comp'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in admin) {
            const line = admin[accountString]
            txt += `${line.fringe || line.account || handlingFee}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"FR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'Admin'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in erLocalAndOtherTaxes) {
            const line = erLocalAndOtherTaxes[accountString]
            txt += `${line.fringe || line.account}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"FR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'EROther'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in fringeAdjustments) {
            const line = fringeAdjustments[accountString]
            txt += `${line.fringe || line.account}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"FR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'PensionHW'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }

          for (const accountString in fringePostage) {
            const line = fringePostage[accountString]
            txt += `${line.fringe || line.account}|${assignment.employeeId}|${line.amount}|${weekEnding}|${line.lastName}|${line.firstName}|${eeTin}|"FR${weekendingAltTwo} ${line.firstName}"|${invNumber}|${'pensionHW'}||"0.00000"|"0.00000"||${projectCode}|${line.set}||US||${paymentNumbers}|${assignment.getNetWagesPay()}|||||||||||||||${invoiceDate}|\r\n`
          }
        }

        this.reportOptions.format = 'txt'
        return txt
      },

      async getAllEmployeesExport () {
        let csv = 'id, tin, last_name, first_name, loanout_name, loanout_fein\n'
        let allEmployeeResources = await this.resources.EmployeeResource.all({ query: { page_size: 50 } })
        allEmployeeResources.forEach((ee) => {
          csv += `${ee.attributes.id},"${ee.attributes.tin}","${ee.attributes.last_name}","${ee.attributes.first_name}","${ee.attributes.loanout_name}","${ee.attributes.fein}"\n`
        })

        // this.showJson = true
        // this.prettyJson = csv
        this.reportOptions.format = 'csv'
        return csv
      },

      async dataFactionExport (payrollData) {
        let txt = ''
        await EmployeeResource.all({ query: { id__in: payrollData.employeeIds.join(',') } })
        await EmployeeDirectDepositRuleResource.all({ query: { id__in: payrollData.employeeIds.join(',') } })
        const sortedAssignments = sortObjectByProperty(payrollData.assignmentsData, 'employeeName')
        for (const id in sortedAssignments) {
          let assignment = sortedAssignments[id]
          const empResource = ((EmployeeResource.getCached(assignment.employeeId) || {}).resource || {})
          const eeTin = empResource.attributes.tin
          const invoiceDate = new Date(payrollData.invoiceDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
          let payStraight = assignment.getDataByCoding('getStraightPay')
          let payOvertime = assignment.getDataByCoding('getOvertimePay')
          let payAllowance = assignment.getDataByCoding('getAllowancePay')
          let payOther = assignment.getDataByCoding('getOtherPay')
          let erBenefitFees = assignment.getDataByCoding('getErBenefitFees')
          let erFica = assignment.getDataByCoding('getErFica')
          let futa = assignment.getDataByCoding('getErFuta')
          let suta = assignment.getDataByCoding('getErSuta')
          let fringeWC = assignment.getDataByCoding('getWcFees')
          let admin = assignment.getDataByCoding('getHandlingFees')
          let erLocalAndOtherTaxes = assignment.getDataByCoding('getErLocalAndOtherTaxes')
          let fringeAdjustments = assignment.getDataByCoding('getErInvAdj')
          let fringePostage = assignment.getDataByCoding('getPostageDelivery')
          let editFormatPeriodEndDate = payrollData.payPeriodEndDate.split('-')
          let periodEndDate = editFormatPeriodEndDate[1] + '/' + editFormatPeriodEndDate[2] + '/' + editFormatPeriodEndDate[0]
          // let periodEndDate = payrollData.payPeriodEndDate.replace(/-/g, '/')
          let accountNum = /\d+/g
          let paymentNumbers = assignment.paymentNumbers || ''
          let weekEnding = new Date(payrollData.weekEnding).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
          let handlingFee = assignment.defaultHandlingCode
          const invNumber = pad((payrollData.payrollNumber || '').substr(-10), '0', 10, 'right')
          for (const accountString in payStraight) {
            const line = payStraight[accountString]
            txt += `${line.account.match(accountNum)}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|PR Straight ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in payOvertime) {
            const line = payOvertime[accountString]
            txt += `${line.account.match(accountNum)}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|PR OT ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in payAllowance) {
            const line = payAllowance[accountString]
            txt += `${line.account.match(accountNum)}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|PR Allow ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in payOther) {
            const line = payOther[accountString]
            txt += `${line.account.match(accountNum)}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|Other PR ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in erBenefitFees) {
            const line = erBenefitFees[accountString]
            txt += `${line.fringe}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|ER Benefits ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in erFica) {
            const line = erFica[accountString]
            txt += `${line.fringe}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|FICA ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in futa) {
            const line = futa[accountString]
            txt += `${line.fringe}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|FUTA ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in suta) {
            const line = suta[accountString]
            txt += `${line.fringe}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|SUTA ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in fringeWC) {
            const line = fringeWC[accountString]
            txt += `${line.fringe}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|WC ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in admin) {
            const line = admin[accountString]
            txt += `${handlingFee}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|Admin ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in erLocalAndOtherTaxes) {
            const line = erLocalAndOtherTaxes[accountString]
            txt += `${line.fringe}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|Other FR ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in fringeAdjustments) {
            const line = fringeAdjustments[accountString]
            txt += `${line.fringe}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|FR ADJ ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
          for (const accountString in fringePostage) {
            const line = fringePostage[accountString]
            txt += `${line.fringe}|||||||${line.lastName} ${line.firstName}|${invoiceDate}|${eeTin}|${line.amount}|${paymentNumbers}|${invNumber}|Postage ${weekEnding}-${periodEndDate} ${line.jobTitle}||||||||${line.loanoutName}|\r\n`
          }
        }
        this.reportOptions.format = 'txt'
        return txt
      },

      async generateReport () {
        this.loading = true
        this.payrollData = {}
        this.disableReportRun = true
        let results

        // Get Payroll Data from sigma-query
        if (this.reportOptions.type === 'getAllEmployees') {
          // allow to continue without a payroll id
        } else if (!this.selectedCodes.doc_number && !this.selectedCodes.transaction_id) {
          this.$notify({ title: 'Please enter a Payroll ID/#', message: `You must enter in a payroll number OR payroll id (not both).`, type: 'error' })
          this.loading = false
          this.disableReportRun = false
          return false
        } else {
          try {
            results = await this.getReportData('payrollinterface')
          } catch (error) {
            console.log('Error')
            console.log(error)
          }

          if (!results || !results.data || !Array.isArray(results.data) || results.data.length === 0) {
            this.$notify({ title: 'No Data', message: 'There were no payrolls found.  Please check the payroll ID or number', type: 'error' })

            // console.log('No results')
            return false
          }
          const responses = results.data[0]
          this.prettyJson = JSON.stringify(results.data[0], null, 2) // Help see why files fail

          this.payrollData = new PayrollInvoiceData(responses)
        }

        // Load project offsets/defaults
        if (this.payrollData.projectId) {
          const project = await this.resources.ProjectResource.detail(this.payrollData.projectId)
          this.payrollData.laborOffset = project.get('labor_clearing_account') || ''
          this.payrollData.fringeOffset = project.get('fringe_clearing_account') || this.payrollData.laborOffset || ''
          // this.payrollData.holidayOffset = project.get('holiday_accrual_account') || fringeOffset || laborOffset || ''
        }

        // Clearing line
        const fileExportType = this.reportOptions.type + 'Export'
        const fileExportData = await this[fileExportType](this.payrollData)
        // this.prettyJson = JSON.stringify(result, null, 2)
        this.prettyJson = fileExportData
        this.loading = false
        this.disableReportRun = false
        // this.createNotification('Success', `${this.payrollData.projectName} Export ${this.payrollData.payrollNumber}-${this.reportOptions.type} is Downloaded.`, 'success', null, null, null, 3)
        this.$notify({ title: 'File Downloaded', message: `${this.payrollData.projectName} Export ${this.payrollData.payrollNumber}-${this.reportOptions.type} is Downloaded.`, type: 'success' })
        this.downloadCsv(`${this.payrollData.payrollNumber}-${this.reportOptions.type}-${this.payrollData.projectName}`, this.reportOptions.format)
        return fileExportData
      },

      reset () {
        this.selectedCodes.doc_number = undefined
        this.selectedCodes.transaction_id = undefined
        this.reportOptions.type = undefined
      },

      // Using typed exports, look for payrolls that have not been exported under PR_CLXP_PB
      async getUnexportedPayrolls () {
        let payrollResources, batchResources
        this.disableReportRun = true

        try {
          // Get PR Records
          payrollResources = sortResourcesByProperty(await this.getUnexportedClientInterfaces(), 'time_posted')

          if (!payrollResources || payrollResources.length === 0) {
            this.$notify({ title: 'No New Transactions', message: 'There are no new payroll entries.', type: 'warning' })
            this.disableReportRun = false
            return null
          }

          // There may be too many resources to load at once because of header size so split it to requests with 50 ids
          // to resolve them.
          const projectIds = [ ...new Set(payrollResources.map((res) => res.attributes.project)) ]
          if (projectIds.length) {
            // Get projects individually since API does not support "in" or "exact" anymore.
            for (const i in projectIds) {
              const id = projectIds[i]
              await this.resources.ProjectResource.detail(id)
            }
          }

          // Need to get the darn bank...
          const batchIds = [ ...new Set(payrollResources.map((res) => res.attributes.batch)) ]
          if (batchIds.length) {
            const splitSize = 50
            const batchSets = sliceIntoChunks(batchIds, splitSize)
            for (const i in batchSets) {
              await this.resources.BatchResource.all({ query: { id__in: batchSets[i].join(',') } })
            }
            batchResources = this.resources.BatchResource.getCachedAll()
            this.bankIds = [ ...new Set(batchResources.map((res) => res.resource).map((res) => res.attributes.bank)) ]
            await this.resources.BankResource.all({ query: { id__in: this.bankIds.join(',') } })
          }

          // Mark resources as resolved
          for (const i in payrollResources) {
            await payrollResources[i].resolveRelated({ managers: [ 'project', 'batch', 'payroll_coordinator' ] })
          }

          for (const i in batchResources) {
            await batchResources[i].resource.resolveRelated({ managers: [ 'bank' ] })
          }
        } catch (error) {
          return error
        } finally {
          this.disableReportRun = false
        }

        this.transactionList = payrollResources
        return payrollResources
      },

      // Select the transaction and run the export
      selectPayrollTransaction (event) {
        this.selectedCodes.transaction_id = event.attributes.id
        const format = event.get('project.format') // remove!!!!!
        if (format) {
          const fileExportType = format + 'Export'
          if (typeof this[fileExportType] !== 'function') {
            return null
          }
          this.reportOptions.type = format
          if (this.generateReport()) event.selected = true
        }
      },

      // Need to group by bank for the API to work properly
      async markAsExported () {
        const selected = this.transactionList.filter((pr) => pr.selected)
        if (selected.length === 0) {
          this.$notify({ title: 'Nothing Selected', message: 'There are no new payrolls selected.', type: 'warning' })
          return
        }

        for (const i in this.bankIds) {
          const bankId = this.bankIds[i]
          const selectedPayrollResources = selected.filter((pr) => pr.get('batch.bank.id') === bankId)
          if (selectedPayrollResources.length) {
            await this.markExportedClientInterfaces(selectedPayrollResources, bankId)
          }
        }

        await this.getUnexportedPayrolls()
      }
    },

    created () {
      // Load data to be used for validation
      this.disableReportRun = true
      this.getCompanyData()
        .then(response => {
          this.allCodes = Object.assign({}, response.data)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.disableReportRun = false
        })
    },

    async mounted () {
      await this.getUnexportedPayrolls()
    },

    beforeDestroy () {
      this.resetComponent()
    }
  }

</script>
<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-top-20 { margin-top: 20px; }
  .m-right-20 { margin-right: 20px; }
</style>
<style>
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>



// WEBPACK FOOTER //
// src/components/Payroll/PayrollClientExport.vue